import { cn } from "@/lib/utils";

interface UKRegPlateProps {
  registration: string;
  size?: "sm" | "md";
  className?: string;
}

export function UKRegPlate({ registration, size = "sm", className }: UKRegPlateProps) {
  if (!registration) return null;
  
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center align-middle leading-none font-bold uppercase rounded-sm border-2 border-black/80",
        "bg-amber-400 text-black",
        size === "sm" && "h-5 text-[10px] px-1.5",
        size === "md" && "h-6 text-xs px-2",
        className
      )}
      style={{ fontFamily: "'UK Number Plate', 'Arial Narrow', monospace" }}
    >
      {/* Negative right margin compensates for trailing letter-spacing so the
          text sits optically centred inside the plate. */}
      <span className="tracking-wider -mr-[0.1em]">{registration.trim()}</span>
    </span>
  );
}

